import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface InterlinkRule {
  id: string;
  keyword: string;
  target_url: string;
  target_type: string | null;
  target_title: string | null;
  target_image: string | null;
  max_uses_per_page: number;
  total_incoming: number;
}

export const useInterlinkRules = () => {
  return useQuery({
    queryKey: ["interlink-rules"],
    queryFn: async () => {
      // Fetch all rules (no 1000 row limit)
      let allData: any[] = [];
      let from = 0;
      const PAGE = 1000;
      while (true) {
        const { data, error: err } = await supabase
          .from("interlink_rules")
          .select("id, keyword, target_url, target_type, target_title, target_image, max_uses_per_page, total_incoming")
          .eq("is_active", true)
          .order("total_incoming", { ascending: true })
          .range(from, from + PAGE - 1);
        if (err) throw err;
        allData = allData.concat(data || []);
        if (!data || data.length < PAGE) break;
        from += PAGE;
      }
      return allData as InterlinkRule[];
    },
    staleTime: 5 * 60 * 1000, // 5 min
    gcTime: 10 * 60 * 1000,
  });
};
